import React, { Component } from "react";
import { withStyles } from "@material-ui/core";
import Button from "components/CustomButtons/Button";
import ChecklistIcon from "@material-ui/icons/ListAlt";
import Boolean from "framework/inputs/Boolean";
import { tl } from "framework/utils/Translator";
import _ from "lodash";
import Cookies from "js-cookie";

class ColumnSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      columns: props.columns
    };

    if (props.name && Cookies.get(props.name+"Columns")) {
      try {
        //set column state based on saved cookie
        let savedColumns = JSON.parse(Cookies.get(props.name+"Columns"))
        this.state.columns = this.state.columns.map((column)=>{
          if (savedColumns.includes(column.field)) {
            return {...column, show:true}
          } else {
            return {...column, show:false}
          }
        })
      } catch (e) {
        console.error(e)
        //replace unparsable cookie with new one
        let columnsToSave = this.state.columns.filter((column)=>column.show).map((column)=>column.field)
        Cookies.set(props.name+"Columns", JSON.stringify(columnsToSave))
      }
    } else if (props.name) {
      //if no cookie, create a new one
      let columnsToSave = this.state.columns.filter((column)=>column.show).map((column)=>column.field)
      Cookies.set(props.name+"Columns", JSON.stringify(columnsToSave))
    }
  }

  togglePane = () => {
    if (!this.state.isOpen) {
      document.addEventListener("click", this.handleClickOutside, false);
    } else {
      document.removeEventListener("click", this.handleClickOutside, false);
    }
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  handleClickOutside = (e) => {
    if (this.node && !this.node.contains(e.target)) {
      this.togglePane();
    }
  };

  handleChange = (field, value) => {
    let newColumns = this.state.columns;
    let fieldIndex = _.findIndex(newColumns, ["field", field]);
    newColumns[fieldIndex].show = value
    this.setState(
      {
        columns: newColumns,
      },
      () => {
        if (this.props.onChange) {
          this.props.onChange(this.state.columns);
        }
        if (this.props.name) {
          // save changes to cookie
          let columnsToSave = this.state.columns.filter((column)=>column.show).map((column)=>column.field)
          Cookies.set(this.props.name+"Columns", JSON.stringify(columnsToSave))
        }
        console.log(this.state.columns);
      },
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container} ref={(node) => (this.node = node)}>
        <Button
          justIcon
          size="sm"
          color="transparent"
          onClick={() => this.togglePane()}
        >
          <ChecklistIcon />
        </Button>
        <div className={"pane " + (this.state.isOpen ? "show" : "")}>
          <div className="title">{tl("columnConfig")}</div>
          <div className="list">
            {this.state.columns.map((column, index) => {
              return (
                <div className="listItem" key={index}>
                  <Boolean
                    inlineLabel
                    field={column.field}
                    label={column.label}
                    value={column.show}
                    renderMode="formEdit"
                    onChange={this.handleChange}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

// const jsonExample = {
//   code: "salesReport",
//   columns: [
//     {
//       field: "date",
//       label: "Tanggal",
//       show: true,
//     },
//     {
//       field: "name",
//       label: "Nama",
//       show: true,
//     },
//     {
//       field: "customer",
//       label: "Pelanggan",
//       show: true,
//     },
//     {
//       field: "payment",
//       label: "Pembayaran",
//       show: true,
//     },
//   ],
// };

const styles = {
  container: {
    position: "relative",
    "&>.pane": {
      position: "absolute",
      backgroundColor: "#fff",
      top: "40px",
      right: "0px",
      opacity: "0",
      minWidth: "280px",
      height: "400px",
      zIndex: "100",
      boxShadow: "0px 5px 10px rgba(0,0,0,0.1)",
      borderRadius: "10px",
      pointerEvents: "none",
      "&>.title": {
        padding: "10px",
        borderBottom: " 1px solid #888",
        fontWeight: "bold",
      },
      "&>.list": {
        overflowY: "auto",
        height: "358px",
        "&>.listItem": {
          width: "100%",
          padding: "5px 10px",
          borderBottom: " 1px solid #eee",
          "&:hover": {
            backgroundColor: "#f8f8f8",
          },
        },
      },
      "&.show": {
        opacity: "1",
        pointerEvents: "all",
      },
    },
  },
};

export default withStyles(styles)(ColumnSelector);
